<template>
    <div class="modal fade" id="modal_regler_trainer" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestTrainerPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        <span v-if="isAdvance">
                            {{ i18n.t('views.clients.trainer.payment.advance') }} </span>
                        <span v-else>
                            {{ i18n.t('views.clients.trainer.payment.title') }}
                        </span>
                    </h5>
                    <button @click="closeModal('modal_regler_trainer', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPaymentTrainer">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="coming-soon col-md-12 text-center position-relative">
                            <h1> UX/UI sera disponible bientôt </h1>
                        </div>
                        <div class="row  ">
                            <div class="col-md-12">
                                <h4 class="title-h4">
                                    {{ i18n.t('views.clients.trainer.payment.info') }}
                                </h4>
                            </div>
                            <div class="col-md-12 mt-3">
                                <div class="row">
                                    <div v-if="trainer?.name" class="col-md-6 mb-2 mt-2">
                                        <p class="timeline-content"><b class="d-inline-block w-160"> {{
                                                i18n.t('tables.members.name') }} </b>:
                                            {{ trainer?.name }} </p>
                                    </div>
                                    <div v-if="trainer?.contractNumber" class="col-md-6 mb-2 mt-2">
                                        <p class="timeline-content"><b class="d-inline-block w-160">{{
                                                i18n.t('tables.members.contractNumber') }}
                                            </b>:
                                            {{ trainer?.contractNumber }} </p>
                                    </div>

                                    <div v-if="trainer?.cin" class="col-md-6 mb-2 mt-2">
                                        <p class="timeline-content"><b class="d-inline-block w-160">{{
                                                i18n.t('tables.members.cin') }}
                                            </b>:
                                            {{ trainer?.cin }} </p>
                                    </div>
                                    <!-- <div v-if="trainer?.adresse" class="col-md-6 mb-2 mt-2">
                                        <p class="timeline-content"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.adresse') }}
                                            </b>:
                                            {{ trainer?.adresse }} </p>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <div class="row ">
                            <div class="col-md-12  mt-4">
                                <h4 class="title-h4">
                                    <!-- {{ i18n.t('views.clients.trainer.payment.paid') }} -->
                                    <span v-if="isAdvance">
                                        {{ i18n.t('views.clients.trainer.payment.advance') }} </span>
                                    <span v-else>
                                        {{ i18n.t('views.clients.trainer.payment.title') }}
                                    </span>
                                </h4>
                            </div>
                            <div class="col-md-12 mt-3">
                                <div class="row ">
                                    <div class="col-md-12">
                                        <div class="form-group mr-b-0em">
                                            <inputText v-model="requestPaymentTrainer.targetMonth"
                                                :label="i18n.t('tables.trainer.targetMonth')" :disabled="true" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group mr-b-0em">
                                            <checkboxInput :text="i18n.t('tables.trainer.add_advance')"
                                                v-model="requestPaymentTrainer.isAdvance" :v="v$.isAdvance"
                                                name="isAdvance" id="isAdvance" />
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <date-field v-model="requestPaymentTrainer.paymentDate"
                                                :label="i18n.t('tables.payment.paymentDate')" :v="v$.paymentDate"
                                                :disabled="false" :fixedDays="1" :isFixedDays="true" />
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')"
                                            :trackby="`id`" :label="`name`" :valueProp="`id`"
                                            v-model="requestPaymentTrainer.paymentMethod"
                                            :placeholder="i18n.t('tables.payment.paymentMethod')"
                                            :arrayOptions="payment_methodsList" refs="paymentMethod"
                                            :v="v$.paymentMethod" />
                                    </div>
                                    <div v-if="requestPaymentTrainer.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                            :label="`name`" :valueProp="`id`" v-model="requestPaymentTrainer.bankName"
                                            :placeholder="i18n.t('tables.payment.bankName')"
                                            :arrayOptions="bank_namesList" refs="bankName" :v="v$.bankName" />
                                    </div>

                                    <div v-if="requestPaymentTrainer.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <inputText v-model="requestPaymentTrainer.chequeName"
                                                :label="i18n.t('tables.payment.chequeName')" :v="v$.chequeName"
                                                :disabled="false" />
                                        </div>
                                    </div>
                                    <div v-if="requestPaymentTrainer.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <inputText v-model="requestPaymentTrainer.chequeNum"
                                                :label="i18n.t('tables.payment.chequeNum')" :v="v$.chequeNum"
                                                :disabled="false" />
                                        </div>
                                    </div>

                                    <div v-if="requestPaymentTrainer.paymentMethod === 'Chèque bancaire'"
                                        class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <date-field v-model="requestPaymentTrainer.dueDate"
                                                :label="i18n.t('tables.payment.dueDate')" :v="v$.dueDate"
                                                :disabled="false" :fixedDays="1" :isFixedDays="false" />
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group mr-b-0em">
                                            <price-input v-model="requestPaymentTrainer.amount_paid"
                                                :label="i18n.t('tables.payment.amount_paid')" :v="v$.amount_paid"
                                                :disabled="false" />
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <p>
                                            <b>{{ i18n.t('tables.trainer.targetMonth') }}
                                            </b>: {{ requestPaymentTrainer.targetMonth }}
                                        </p>
                                        <p>
                                            <b>{{ i18n.t('tables.payment.paymentDate') }}
                                            </b>: {{ formatDate(requestPaymentTrainer.paymentDate) }}
                                        </p>
                                        <p>
                                            <b>{{ i18n.t('tables.trainer.salary') }}
                                            </b>: {{
                                            trainer?.salary ?? 0 }} {{
                                            i18n.t('symbole.currency.mad') }}
                                        </p>
                                        <p>
                                            <b>{{ i18n.t('tables.trainer.total_advance') }}
                                            </b>: {{
                                            trainer?.total_advance ?? 0 }} {{
                                            i18n.t('symbole.currency.mad') }}
                                        </p>
                                        <p>
                                            <b>{{ i18n.t('tables.trainer.total_paid') }}
                                            </b>: {{
                                            trainer?.total_paid ?? 0 }} {{
                                            i18n.t('symbole.currency.mad') }}
                                        </p>
                                        <p>
                                            <b>{{ i18n.t('tables.trainer.remaining_salary') }} </b>: {{
                                            trainer?.remaining ?? 0 }} {{
                                            i18n.t('symbole.currency.mad') }}
                                        </p>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button type="submit" class="btn btn-primary mr-2">
                                    {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                                </button>
                                <button type="button" @click="emptyState()" class="btn btn-cancel">
                                    {{ i18n.t('button.cancel') }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, toRefs, Ref, watchEffect } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import checkboxInput from "@/components/inputsValidation/checkboxInput.vue";


/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, helpers, requiredIf } from "@vuelidate/validators";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useTrainerPayment } from "@/composables/trainer/useTrainerPayment";
import { clubUUID, bank_names, payment_methods } from "@/shared/state";
import { TrainerPaymentRequest } from "@/interfaces/trainer";
import { useGlobal } from "@/composables/global/useGlobal";


export default defineComponent({
    components: { inputText, SingleSelect, checkboxInput },
    name: "regler-trainer",
    props: {
        trainer: {
            type: Object,
            default: null,
        },
        targetMonth: {
            type: Object,
            default: null,
        },
        isAdvance: {
            type: Number,
            default: null,
        }
    },
    setup(props) {
        const { trainer, isAdvance, targetMonth } = toRefs(props);
        const action = ref('add')

        const requestPaymentTrainer = ref<TrainerPaymentRequest>({
            trainer_id: trainer?.value?.id,
            clubUUID: clubUUID.value,
            personType: null,
            amount_paid: null,
            targetMonth: null,
            paymentMethod: null,
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: null,
            paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            isAdvance: isAdvance.value
        });

        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const { closeModal } = useModal();
        const { formatDate } = useGlobal();
        const { addPayment, isRequestTrainerPayment, errorTrainerPayment } = useTrainerPayment();


        // Validation 
        const rules = {
            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            trainer_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },

            paymentMethod: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            paymentDate: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            bankName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentTrainer?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentTrainer?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeNum: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentTrainer?.value?.paymentMethod === 'Chèque bancaire'))
            },
            dueDate: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentTrainer?.value?.paymentMethod === 'Chèque bancaire')),
            },

            amount_paid: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentTrainer?.value?.paymentMethod !== null)),
                numeric,
                paidAmountValid: helpers.withMessage(
                    i18n.t("validation.amountExceededError"),
                    (value) => {
                        const numberValue = Number(value);
                        return numberValue !== null && numberValue <= (trainer?.value?.remaining ?? 0);
                    }
                )

            }

        };
        const v$ = useVuelidate(rules, requestPaymentTrainer as Ref<Required<TrainerPaymentRequest>>, { $scope: 'payment-icome' });

        /**
         * Add or edit Service
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await addPayment(requestPaymentTrainer.value);
                    if (!errorTrainerPayment.value)
                        emptyState()

                }

            }
        }


        const emptyState = () => {
            action.value = 'add';
            requestPaymentTrainer.value.id = null
            requestPaymentTrainer.value.personType = null
            requestPaymentTrainer.value.bankName = null
            requestPaymentTrainer.value.chequeName = null
            requestPaymentTrainer.value.chequeNum = null
            requestPaymentTrainer.value.amount_paid = null
            requestPaymentTrainer.value.dueDate = null
            requestPaymentTrainer.value.paymentMethod = null
            requestPaymentTrainer.value.isAdvance = isAdvance.value
            // requestPaymentTrainer.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            if (isAdvance.value) {
                requestPaymentTrainer.value.paymentDate = dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD');
            } else {
                requestPaymentTrainer.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            }

            v$.value.$reset();
            closeModal('modal_regler_trainer', 'add')
        };



        watchEffect(() => {
            // Format YYYY-MM
            if (targetMonth.value) {
                const year = targetMonth.value.year;
                const month = targetMonth.value.month + 1
                requestPaymentTrainer.value.targetMonth = `${year}-${month}`;
            }

            requestPaymentTrainer.value.trainer_id = trainer?.value?.id
            if (isAdvance.value) {
                requestPaymentTrainer.value.paymentDate = dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD');
            } else {
                requestPaymentTrainer.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            }

        });


        return {
            requestPaymentTrainer,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,
            bank_namesList,
            payment_methodsList,
            closeModal,
            isRequestTrainerPayment,
            formatDate
        };
    },
});
</script>
